import { useState } from 'react';

import { SettingsEntryList } from 'features/settings/components/SettingsEntryList';
import { SettingsOverlay } from 'features/settings/components/SettingsOverlay';

import { useCompanyPartnerTypes } from '../api/getCompanyPartnerTypes';
import { PartnerTypesModal } from './PartnerTypesModal';

export const SettingsTab = ({ companyId, companyName, companyType }) => {
  const [openOverlay, setOpenOverlay] = useState(null);
  const isSupplier = companyType === 'supplier';
  const { data: partnerTypes, refetch: refetchPartnerTypes } = useCompanyPartnerTypes(companyId, {
    enabled: !!companyId && isSupplier,
  });

  const items = [
    { label: 'Fees', onClick: () => setOpenOverlay('fees') },
    ...(isSupplier
      ? [
          {
            label: 'Partner',
            count: `${partnerTypes.filter(({ selected }) => selected).length}/${partnerTypes.length}`,
            onClick: () => setOpenOverlay('partner'),
          },
        ]
      : []),
  ];

  return (
    <SettingsEntryList items={items}>
      {openOverlay === 'fees' && (
        <SettingsOverlay
          name={companyName}
          companyId={companyId}
          onClose={() => setOpenOverlay(null)}
        />
      )}
      {isSupplier && (
        <PartnerTypesModal
          companyId={companyId}
          partnerTypes={partnerTypes}
          open={openOverlay === 'partner'}
          handleClose={() => setOpenOverlay(null)}
          refetch={refetchPartnerTypes}
        />
      )}
    </SettingsEntryList>
  );
};
